export enum SESSION_STATUS_ENUM {
  DEFAULT = 'DEFAULT',
  FORBIDDEN = 'FORBIDDEN',
  LOGGED_OUT = 'LOGGED_OUT',
  NOT_ALLOWED = 'NOT_ALLOWED',
  UNAVAILABLE = 'UNAVAILABLE',
}
